export default __webpack_public_path__ + "static/Christian Lisangan-4a4fe61572fbc58666c6f91a63dc469d.webp";